<template>
  <div class="">
    <!-- ============ CONTENT ============ -->
    <div>
      <!-- Live header -->
      <div class="live-detail-header">
        <div class="step-h">
          {{ title }}
        </div>
        <template v-if="title == 'state_of_charge'">
          <div class="live-tag">
            <span class="live-pulse" />LIVE
          </div>
          <div class="live-detail-sub">
            {{ item.sub || "Charging in progress" }}
          </div>
        </template>
      </div>
      <state-of-charge
        v-if="selectedFlow == 'state_of_charge'"
        :item="selectedRow"
        @click="(v) => (selectedFlow = v)"
      />
      <div v-else-if="selectedFlow == 'take_payment'">
        <take-payment
          :item="selectedRow"
          @click="(v) => (selectedFlow = v)"
        />
      </div>
      <div v-else-if="selectedFlow == 'booking_completed'">
        <booking-completed
          :item="selectedRow"
          @click="$emit('click', 'close')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SelectedLiveSessions",
  components: {
    StateOfCharge: () => import("../utils/StateOfCharge.vue"),
    TakePayment: () => import("../utils/TakePayment.vue"),
    BookingCompleted: () => import("../utils/BookingCompleted.vue"),
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default() {
        return "content";
      },
    },
  },
  data() {
    return {
      flow: [
        { key: "state_of_charge", name: "" },
        { key: "take_payment", name: "Collect Payment" },
        { key: "booking_completed", name: "Booking Completed" },
      ],
      selectedFlow: "state_of_charge",
    };
  },
  computed: {
    ...mapGetters({
      liveSessionList: "bookingOperator/getLiveSession",
    }),
    title() {
      return this.flow.find((r) => r.key === this.selectedFlow)?.name || "";
    },
    selectedRow() {
      const id = this.item?.booking_id || this.item?.session_id || null;
      return this.liveSessionList.find((r) => r.booking_id == id) || [];
    },
  },
  watch: {
    item() {
      this.selectedFlow = "state_of_charge";
    },
  },
  methods: {},
};
</script>

<style scoped>
/* ---------- Live header ---------- */
.live-detail-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}
.live-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--gradient);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.5px;
  padding: 4px 10px;
  border-radius: 999px;
}
.live-pulse {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  animation: sls-pulse 1.4s ease-in-out infinite;
}
@keyframes sls-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(0.7);
  }
}
@media (prefers-reduced-motion: reduce) {
  .live-pulse {
    animation: none;
  }
  .soc-ring__fill {
    transition: none !important;
  }
}
.live-detail-sub {
  font-size: 14px;
  font-weight: 600;
  color: var(--muted);
}
</style>
